<template>
  <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-1 tm-grid-hover rows" data-uk-grid data-uk-accordion>
    <template v-for="(item, index) in items">
      <div class="uk-animation-fade uk-animation-fast uk-position-relative uk-text-small tm-rating-row "
           style="animation-fill-mode: inherit;"
           :key="item.date.week + '_' + index"
           v-if="item"
           :id="item.date.week">
        <!--строка-->
        <div class="uk-grid uk-grid-collapse uk-flex-middle uk-text-center" data-uk-grid>
          <div class="uk-text-left tm-width-medium">
            <div v-if="item.date" class="uk-padding-xsmall">
              <div class="uk-text-bold"  :class="{ 'tm-week-red-notification': getNotiferForWeek(item.date.week) }">{{ item.date.week ? item.date.week : '-' }}</div>
              <div class="tm-text-small uk-text-muted">
                ({{ item.date.start ? item.date.start : '-' }} / {{ item.date.end ? item.date.end : '-' }})
              </div>
            </div>
          </div>
          <!--бонусы, рейтинги-->
          <div class="uk-width-small">
            <div v-for="(field, fieldKey) in fields" :key="fieldKey">
              <div v-if="field.key === 'weekly-bonus'" class="uk-padding-xsmall uk-position-relative uk-position-z-index">
                <div v-if="choosenRole === 'pro-retoucher'" class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                  <template v-if="Object.keys(items[index].bonus.salaryToWeekBonusStat).length > 0">
                    <div class="uk-width-1-1">
                      {{ items[index].bonus.salaryToWeekBonusStat.allBonus | round}}%
                      <span class="tm-pro-rating" v-show="items[index].bonus && items[index].bonus.place">
                          <template v-if="items[index].bonus && items[index].bonus.place">
                            (#{{ items[index].bonus.place ? items[index].bonus.place : "" }}{{ items[index].bonus.place && [1, 2, 3].includes(items[index].bonus.place) ? "🏆" : "" }})
                          </template>
                        </span>
                      <RatingDialog v-if="items[index] && items[index].bonus"
                                    :bonus-data="items[index].bonus"
                                    :dialogClass="'tm-dropdown-bottom-center'"
                                    :dialogOffset="'10'"
                                    :dialogPosition="'bottom-center'"/>
                    </div>
                    <div> {{ items[index].bonus.salaryToWeekBonusStat.weekBonus | round }}% </div>
                    <div v-if="showQuality"
                         class='tm-bonus-add'
                         :class="items[index].bonus.salaryToWeekBonusStat.additional_bonus_pro === 0 ? 'tm-bonus-add-grey' : ''"
                         :data-uk-tooltip="'title:' + local_page_keys.tooltip_additional_bonus">
                      +{{ items[index].bonus.salaryToWeekBonusStat.additional_bonus_pro }}%
                    </div>
                    <div v-if="showSloppy"
                         class='tm-bonus-add'
                         :class="getPenalty(item) === 0 ? 'tm-bonus-add-grey' : 'tm-bonus-add-red'"
                         :data-uk-tooltip="'title:' + local_page_keys.tooltip_sloppy_work">
                      -{{ items[index].bonus.salaryToWeekBonusStat.additional_penalty_pro }}%
                    </div>
                  </template>
                  <template v-else>
                    <div class="uk-width-1-1">
                      {{ getData(item, field.key, 'percent') + getAdditionalBonus(item) | round}}%
                      <span class="tm-pro-rating" v-show="items[index].bonus && items[index].bonus.place">
                        <template v-if="items[index].bonus && items[index].bonus.place">
                          (#{{ items[index].bonus.place ? items[index].bonus.place : "" }}{{ items[index].bonus.place && [1, 2, 3].includes(items[index].bonus.place) ? "🏆" : "" }})
                        </template>
                      </span>

                      <RatingDialog v-if="items[index] && items[index].bonus"
                                    :bonus-data="items[index].bonus"
                                    :dialogClass="'tm-dropdown-bottom-center'"
                                    :dialogOffset="'10'"
                                    :dialogPosition="'bottom-center'"/>
                    </div>
                    <div> {{ getFullbonus(getData(item, field.key, 'percent'),item) | round }}% </div>
                    <div v-if="showQuality"
                         class='tm-bonus-add'
                         :class="getAdditionalBonus(item) === 0 ? 'tm-bonus-add-grey' : ''"
                         :data-uk-tooltip="'title:' + local_page_keys.tooltip_additional_bonus">
                      +{{ getAdditionalBonus(item) }}%
                    </div>
                    <div v-if="showSloppy"
                         class='tm-bonus-add'
                         :class="getPenalty(item) === 0 ? 'tm-bonus-add-grey' : 'tm-bonus-add-red'"
                         :data-uk-tooltip="'title:' + local_page_keys.tooltip_sloppy_work">
                      -{{ getPenalty(item) }}%
                    </div>
                  </template>


                </div>
                <div v-else-if="choosenRole === 'retoucher' || choosenRole === 'junior-retoucher'" class="uk-position-relative">
                  <template v-if="index === 0">
                    <div class="uk-display-inline-block" :data-uk-tooltip="'pos: bottom; title: ' + getTooltipRetoucherSummaryBonus(item.rating, fieldKey)">
                      {{ item.rating[field.key]['percent'] }}%
                    </div>
                    <!--Зеленый инидикатор о старте 25% бонуса каждый понедельник-->
                    <div v-if="isShowRetoucherNotification()" class="uk-position-top-right" style="right: 35px;top: -10px;">
                      <div class="tm-bonus-green-notification"></div>
                      <div id="notification-start-bonus"
                           class="uk-dropdown tm-dropdown tm-dropdown-top-center"
                           data-uk-dropdown="pos: top; offset: 10">
                        {{ local_page_keys.notification_start_bonus_of_week_retoucher }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    {{ item.rating[field.key]['percent'] }}%
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-expand">
            <div class="uk-grid uk-grid-collapse uk-flex-middle tm-hide-first-element" :class="'tm-child-width-1-' + countFieldItem" data-uk-grid>
              <div v-for="(field, fieldKey) in fields" :key="fieldKey">
                <div v-if="field.key === 'weekly-salary'" class="uk-padding-xsmall uk-position-relative_ uk-position-z-index_" data-uk-tooltip="title: Дата выплаты">
                  200 грн.
                </div>
                <div v-else-if="field.key !== 'weekly-bonus'" class="uk-padding-xsmall">
                  {{ getData(item, field.key, 'count') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--активная зона-->
        <a :id="item.date.week" class="uk-accordion-title uk-position-cover" v-show="getIsNotEmpty(item)"></a>
        <!--разворачивающийся блок под строкой-->
        <div class="uk-accordion-content uk-margin-remove" v-if="getIsNotEmpty(item)">
          <hr class="uk-margin-remove">
          <div class="uk-padding-small tm-small-stars tm-close-stars">
            <div class="uk-grid uk-grid-small uk-grid-divider uk-child-width-1-1" data-uk-grid>
              <template v-for="(field, fieldKey) in fields">
                <div :key="fieldKey" v-if="field.withOrders && getData(item, field.key, 'count') > 0">
                  <!--строка-->
                  <div class="uk-grid uk-flex-middle" data-uk-grid>
                    <!--иконки-->
                    <div class="uk-width-small uk-text-muted uk-flex uk-flex-middle" v-if="field.icon">
                      <span class="material-icons"
                            :data-uk-tooltip="'pos: right; title: ' + (field.title ? field.title : '')"
                            v-for="iconKey in field.countIcons"
                            :key="iconKey">
                        {{ field.icon }}
                      </span>
                    </div>
                    <div v-if="choosenRole === 'retoucher' || choosenRole === 'junior-retoucher'" class="uk-width-auto uk-text-small">
                      <div style="width: 60px" class="uk-text-bold uk-text-center"   :data-uk-tooltip="'pos: right; title: ' + getTooltipPercentages(item.rating['weekly-bonus'],field.key)"
                           :class="formatPercentForRetoucher(item.rating['weekly-bonus'], field.key).class">
                        {{ formatPercentForRetoucher(item.rating['weekly-bonus'], field.key).value }}
                      </div>
                    </div>
                    <div v-if="choosenRole === 'pro-retoucher'" class="uk-width-auto uk-text-small">
                      <div style="width: 60px" class="uk-text-bold uk-text-center"  :data-uk-tooltip="'pos: right; title: ' + getTooltipPercentages(item.rating['weekly-bonus'],field.key)"
                           :class="formatPercentForProRetoucher(item.rating['weekly-bonus'], field.key).class">
                        {{ formatPercentForProRetoucher(item.rating['weekly-bonus'], field.key).value }}
                      </div>
                    </div>
                    <!--список-->
                    <div class="uk-width-expand">
                      <div class="uk-grid uk-grid-small uk-text-small" data-uk-grid>
                        <div v-for="(order, orderKey) in getData(item, field.key, 'items')" :key="orderKey">
                          <a v-if="order && order.order_id"
                             :href="'#'+order.order_id"
                             :id="'orderId-' + order.order_id"
                             class="uk-link-reset tm-link-visited"
                             @click="openOrder(orderKey, getData(item, field.key, 'items'),field.key, item.date.week)"
                             :data-uk-tooltip="'title:' + getTooltipForOrder(field.key,order.senior_retoucher_quality,order.last_type_comment === 'pro_retoucher_comment', order.commented_proretoucher && order.commented_proretoucher === user_id , order.last_type_comment)">
                            {{ order.order_id }}
                            <template v-if="showQuality">
                              <template v-if="(order.last_type_comment === 'senior_comment' || order.last_type_comment === null || ignoreIsLastUserChat.includes(order.order_id))">
                                <md-icon class="tm-senior-mark-icon"
                                         :class="getSeniorQualityIcon(order, false, field.key).class"
                                         v-if="getSeniorQualityIcon(order,false,field.key).icon">
                                  {{ getSeniorQualityIcon(order,false,field.key).icon }}
                                </md-icon>
                              </template>
                              <template v-else-if="order.last_type_comment === 'pro_retoucher_comment'">
                                <md-icon class="tm-senior-mark-icon" :class="getProRetoucherCommentIcon(order.commented_proretoucher === user_id).class">
                                  {{ getProRetoucherCommentIcon(order.commented_proretoucher === user_id).icon }}
                                </md-icon>
                              </template>
                            </template>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RatingDialog from "./Dialogs/RatingDialog.vue";

export default {
  name: "RatingTableItem",
  components: {RatingDialog},
  data() {
    return {
      ignoreIsLastUserChat: [],
    };
  },
  filters: {
    round: function(value) {
      return  value !== '-' ? Math.round(value) : value;
    }
  },
  props: {
    items: {
      type: Array,
      require: true
    },
    getSeniorQualityIcon: {
      type: Function,
      require: true
    },
    getProRetoucherCommentIcon: {
      type: Function,
      require: true
    },
    getData: {
      type: Function,
      require: true
    },
    getIsNotEmpty: {
      type: Function,
      require: true
    },
    fields: {
      type: Array,
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    showQuality: {
      type: Boolean,
      require: true
    },
    showSloppy: {
      type: Boolean,
      require: true
    },
   chosenUserEmail: String,
   user_id: Number,
   role: String,
   notiferForWeeksData:Array,
   countFieldItem: Number,
  choosenRole: String
  },
  methods: {
    addIconToOrder(data, type) {
      const targetId = 'orderId-' + data.order_id;
      const anchorElements = document.querySelectorAll(`[id="${targetId}"]`);
      anchorElements.forEach(anchorElement => {
        const iconsToRemove = anchorElement.querySelectorAll('i');
        iconsToRemove.forEach(icon => {
          anchorElement.removeChild(icon);
        });
        const iconElement = document.createElement('i');
        if (type === 'quality') {
          let orderFake = { 'senior_retoucher_quality': data.quality, 'commented_proretoucher': data.pro_retoucher };
            iconElement.className = 'md-icon md-icon-font tm-senior-mark-icon md-theme-default ' + this.getSeniorQualityIcon(orderFake, true).class;
            iconElement.innerText = this.getSeniorQualityIcon(orderFake, true).icon
        } else if (type === 'pro-retoucher-comment') {
          iconElement.className = 'md-icon md-icon-font tm-senior-mark-icon md-theme-default ' + this.getProRetoucherCommentIcon(true).class;
          iconElement.innerText = this.getProRetoucherCommentIcon(true).icon
        }
        anchorElement.appendChild(iconElement);
      });
    },
    isLastUserChat(chat) {
      if (chat) {
        let data = JSON.parse(chat)
        let lastObject = data[data.length - 1];

        if (lastObject.role === 'pro-retoucher' && lastObject.pro_retoucher_comment) {
          return lastObject.role;
        } else if (lastObject.role === 'senior-retoucher')
          return lastObject.role;
      }
    },
    getNotiferForWeek(week) {
      if (this.role !== 'pro-retoucher')
        return;
      const foundWeek = this.notiferForWeeksData.find(item => item.week === week);
      return foundWeek ? foundWeek.value > 0 : null;
      },
    getAdditionalBonus(items) {
      let bonus = 0;
      if (items) {

        if (this.checkSloppyWorkRating(items)) {
          return bonus;
        }

        if (this.checkOnly5Star(items)) {
          bonus = 10;
        } else {
          const properties = Object.keys(items.rating);
          let niceCount = 0;
          let totalCount = 0;
          for (const prop of properties) {
            const targetElement = this.fields.find(item => item.key === parseInt(prop) && item.key !== 5);
          //  if ((targetElement && targetElement.withOrders) || prop === 'returned' || prop === 'senior-dislike' || prop === 'number_of_rejected_orders') {
            if ((targetElement && targetElement.withOrders)  || prop === 'senior-dislike') {
              const data = items.rating[prop].items;
              if (data) {
                const totalFiltered = data.filter(item => item.commented_proretoucher === this.user_id || !item.commented_proretoucher);
                const niceFiltered = totalFiltered.filter(item =>  item.senior_retoucher_quality === "nice-job");

                totalCount += totalFiltered.length;
                niceCount += niceFiltered.length;
              }
            }
          }
          bonus =  (totalCount !== 0 && totalCount === niceCount) ? 10 : 0;
        }
      }
      return bonus;
    },
    getPenalty(items) {
      return items.rating['sloppy-work'].items.length * 10;
    },
    checkOnly5Star(items) {
      function hasUndesiredRatings(rating) {
        return ['1', '2', '3', '4'].some(key => key in rating);
      }

      const filteredData = Object.keys(items.rating)
          .filter(key => key === '5' && !hasUndesiredRatings(items.rating)  && items.rating['senior-dislike'].count === 0 && items.rating['number_of_rejected_orders'].count === 0)
          .map(key => ({
            [key]: items.rating[key]
          }));
      return filteredData.length;
    },
    checkSloppyWorkRating(items) {
      return items.rating['sloppy-work'].items.some(item => item.senior_retoucher_quality === 'bad-job' && item.commented_proretoucher === this.user_id
          //    && item.last_type_comment !== 'pro-retoucher-comment'
      );
    },
    changeSeniorRetoucherQuality(data) {
      if (data.pro_retoucher !== this.chosenUserEmail)
        return;
      this.items.forEach(item => {
        for (const key in item.rating) {
          if (item.rating[key].items) {
            const foundItem = item.rating[key].items.find(el => el.order_id === data.order_id);
            if (foundItem) {
              foundItem.senior_retoucher_quality = data.quality;
              foundItem.commented_proretoucher = data.pro_retoucher;
              this.ignoreIsLastUserChat.push(data.order_id)
              this.addIconToOrder(data,'quality')
            }
          }
        }
      });
    },
    insertToCurrentWeekAllComments(data) {
      if (data.pro_retoucher !== this.chosenUserEmail)
        return;

      if(data.isExistBadComment)
        return;

      let container = document.querySelector('.rows');
      if (!container)
        return;

      let element = container.querySelector('.tm-rating-row');
      if (element) {
        let week = element.id;
        let index = this.items.findIndex(item => item.date.week === Number(week))

        if (this.items[index]) {
          if (data.sloppy_work) {

            if (!this.items[index].rating['sloppy-work']) {
              this.items[index].rating['sloppy-work'] = {
                items: [],
                count: 0
              }
            }

            const itemsSloppyWork = this.items[index].rating['sloppy-work'].items;
            const existingIndexSloppyWork = itemsSloppyWork.findIndex(item => item.order_id === data.order_id);

            if (existingIndexSloppyWork !== -1) {
              itemsSloppyWork[existingIndexSloppyWork].senior_retoucher_quality = data.quality;
            } else {
              this.items[index].rating['sloppy-work'].items.push({
                'order_id': data.order_id,
                'senior_retoucher_quality': data.quality
              });
              this.items[index].rating['sloppy-work'].count++;
            }
          }

          // if (!this.items[index].rating[this.activeOrderField]) {
          //   this.items[index].rating[this.activeOrderField] = {
          //     items: [],
          //     count: 0
          //   }
          // }
          //
          // this.items[index].rating[this.activeOrderField].items.push({
          //   'order_id': data.order_id,
          //   'senior_retoucher_quality': data.quality
          // });
          // this.items[index].rating[this.activeOrderField].count++;

          if (!this.items[index].rating['senior-dislike']) {
            this.items[index].rating['senior-dislike'] = {
              items: [],
              count: 0
            }
          }

          if (data.quality === 'bad-job') {

            const itemsSeniorDislike = this.items[index].rating['senior-dislike'].items;
            const existingIndexSeniorDislike = itemsSeniorDislike.findIndex(item => item.order_id === data.order_id);

            if (existingIndexSeniorDislike !== -1) {
              itemsSeniorDislike[existingIndexSeniorDislike].senior_retoucher_quality = data.quality;
            } else {
              this.items[index].rating['senior-dislike'].items.push({
                'order_id': data.order_id,
                'senior_retoucher_quality': data.quality
              });
              this.items[index].rating['senior-dislike'].count++;
            }
          }
        }
      }
     // this.activeOrderField = null;
    },
    getTooltipForOrder(rating, quality, blue, isOwner, type) {
      let text = '';
      if (rating === 5) {
        text = this.local_page_keys.tooltip_order_5;
      } else if (rating !== 5 && quality === '' && !blue) {
        text = this.local_page_keys.tooltip_order_without_5_no_quality;
      } else if (rating !== 5 && (quality === 'nice-job' || quality === 'good-bad-job') && !blue) {
        text = this.local_page_keys.tooltip_order_without_5_green;
      } else if (rating !== 5 && quality === 'bad-job' && !blue) {
        text = this.local_page_keys.tooltip_order_without_5_red;
      } else if (rating !== 5 && blue) {
        text = this.local_page_keys.tooltip_order_without_5_blue;
      }
      if (type === 'pro_retoucher_comment' && !isOwner)
        text = this.local_page_keys.tooltip_order_no_owner_pro_comment;
      else if (quality && !isOwner)
        text = this.local_page_keys.tooltip_order_no_owner;

      return text;
    },
    openOrder(orderKey, orders, field, week){
      if (!isNaN(parseInt(orders[orderKey].order_id)) && isFinite(orders[orderKey].order_id)) {
        this.$emit('openOrder', {key: orderKey, orders: orders, week: week})
      }
      //this.activeOrderField = field;
    },
    getFullbonus(bonus, item) {
      let bonusNum = +bonus ||  0;
     // let additionalBonus = +this.getAdditionalBonus(item) || 0;
      let penalty = +this.getPenalty(item) || 0;

     // return  bonusNum + additionalBonus + penalty;// + penalty потому что в bonusNum уже учтено
      return  bonusNum + penalty;// + penalty потому что в bonusNum уже учтено
    },
    isViewForProretoucher(commented_proretoucher) {
      return commented_proretoucher === this.user_id;
    },
    formatPercentForRetoucher(item, key) {
      let value = item['percentages']  ? item['percentages'][key] : 0;
      let data = { 'value': `${value}%`, 'class': 'tm-color-grey'}

      if (value > 0) {
        data.value = `+${value}%`;
        data.class = 'tm-color-green';
      } else if ( value < 0) {
        data.value = `${value}%`;
        data.class = 'tm-color-red';
      }

      return data;
    },
    formatPercentForProRetoucher(item, key) {
      let data = { 'value': '', 'class': ''}

      if (item['percentages'].length === 0 && !item['percentages'][key])
        return data;

      let value =  item['percentages'][key];

      if (value > 0) {
        data.value = `+${value}%`;
        data.class = 'tm-color-green';
      } else if ( value < 0) {
        data.value = `${value}%`;
        data.class = 'tm-color-red';
      } else if (value === 0){
        data.class = 'tm-color-grey';
        data.value = `${value}%`;
      }

      return data;
    },
    getTooltipPercentages(item, field) {
      if (typeof item['percentages'] === 'undefined' || typeof item['percentages']['detail'] === 'undefined' || typeof item['percentages']['detail'][field] === 'undefined')
        return ''

      return item['percentages']['detail'][field]['count'] + ' * ' + item['percentages']['detail'][field]['percent'] + '%';
    },
    getTooltipRetoucherSummaryBonus(items) {

      if (typeof items['weekly-bonus'] === 'undefined' || typeof items['weekly-bonus']['percentages'] === 'undefined' || typeof items['weekly-bonus']['percentages']['detail'] === 'undefined') {
        return '';
      }

      //чтобы показать только те значения, которые отображаются
      let keys = Object.keys(items)
      let filteredKeys = keys.filter(key => key !== "total" && key !== "weekly-bonus" && key !== "number_of_rejects").reverse();
      let sortOrder = [5, 4, 3, 2, 1, "slung", "number_of_rejected_orders"];

      filteredKeys.sort((a, b) => {
        let indexA = sortOrder.indexOf(a);
        let indexB = sortOrder.indexOf(b);

        return indexA - indexB;
      });

      return items['weekly-bonus']['percentages']['start_bonus'] + '% ' +  filteredKeys.map(key => {
        let value = items['weekly-bonus']['percentages'][key];
        return (value >= 0) ? `+${value}%` : `${value}%`;
      }).join(' ') + '. ' + this.local_page_keys.tooltip_retoucher_summary_bonus_additional;
    },
    openNotificationStartBonus() {
      let dataAttribute = document.getElementById('notification-start-bonus');
      if (dataAttribute) {
        UIkit.dropdown(dataAttribute).show();
      }
    },
    showRetoucherTour() {
      const week = this.getCurrentWeekNumber();
      const weekKey = `weekShowTourRetoucher_${week}`;
      const tourShownInWeek = localStorage.getItem(weekKey);
      if (!tourShownInWeek) {
        this.openNotificationStartBonus();
        localStorage.setItem(weekKey, 'true');
      }
    },
    getCurrentWeekNumber() {
      const now = new Date();
      const startOfYear = new Date(now.getFullYear(), 0, 1);
      const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000;
      const millisecondsSinceStartOfYear = now - startOfYear;
      return Math.ceil(millisecondsSinceStartOfYear / millisecondsPerWeek);
    },
    isShowRetoucherNotification() {
      const today = new Date();
      if ( (this.role === 'retoucher' || this.role === 'junior-retoucher' ) && today.getDay() === 1) {
        return true;
      }
    }
  },
  created() {
    this.$root.$on('quality-senior-updated', (data) => {
      this.insertToCurrentWeekAllComments(data);
      this.changeSeniorRetoucherQuality(data);
      this.addIconToOrder(data,'quality')
    });
    this.$root.$on('pro-retoucher-comment-chat', (data) => {
      this.addIconToOrder(data, 'pro-retoucher-comment')
    });
  },
  updated() {
    this.$nextTick(() => {
      this.showRetoucherTour();
    });
  },
}
</script>

<style>

  .tm-hide-first-element > div:first-child {
    display: none;
  }
  .tm-rating-row:hover {
    z-index: 20;
  }
  .tm-week-red-notification {
    position: relative;
  }
  .tm-week-red-notification:after {
    content: '';
    background-color: red;
    border-radius: 10px;
    width: 6px;
    height: 6px;
    display: block;
    position: absolute;
    top: 0px;
    left: 20px;
  }
</style>
